<template>
  <div class="dropdown">
    <h5
        class="dropdown-toggle"
        id="annualSummitDropdown"
        data-toggle="dropdown"
        aria-expanded="false"
        @click="showDropdown = !showDropdown"
    >
      {{ status === 'success' ? item.EventTitle : 'Event Info' }}
    </h5>
    <el-empty :image-size="100" v-if="['not-found', 'error'].includes(status)"></el-empty>
    <div
        v-else
        class="event-box-shadow event-left-content-inner dropdown-menu"
        :class="{show: showDropdown}"
        aria-labelledby="annualSummitDropdown"
    >
      <div class="event-card-head">
        <div class="d-flex">
          <div class="event-card-avatar">
            <div class="event-initial-bg"></div>
            <div class="event-initial-text font-light"><img src="../../assets/icons/date-icon.svg" alt="User"></div>
          </div>
          <div class="event-card-title">
            <div class="event-individual-price font-light">Date</div>
            <div class="event-individual-title">{{ eventBeginDate }}</div>
          </div>
        </div>
      </div><!-- /.event-card-head -->
      <div class="row">
        <div class="col-6">
          <div class="event-card-head my-0">
            <div class="d-flex">
              <div class="event-card-avatar">
                <div class="event-initial-bg"></div>
                <div class="event-initial-text font-light"><img src="../../assets/icons/clock-icon.svg" alt="Clock">
                </div>
              </div>
              <div class="event-card-title">
                <div class="event-individual-price font-light">{{ isTBA ? 'Time' : 'From' }}</div>
                <div class="event-individual-title">{{ eventBeginTime }}</div>
              </div>
            </div>
          </div><!-- /.event-card-head -->
        </div>
        <div v-if="!isTBA" class="col-6">
          <div class="event-card-head my-0">
            <div class="d-flex">
              <div class="event-card-title">
                <div class="event-individual-price font-light">To</div>
                <div class="event-individual-title">{{ eventEndTime }}</div>
              </div>
            </div>
          </div><!-- /.event-card-head -->
        </div>
      </div><!-- /.row -->
      <div class="event-card-head" v-if="item.EventRSVPDateTime">
        <div class="d-flex">
          <div class="event-card-avatar">
            <div class="event-initial-bg"></div>
            <div class="event-initial-text font-light"><img src="../../assets/icons/date-icon.svg" alt="Date"></div>
          </div>
          <div class="event-card-title">
            <div class="event-individual-price font-light">RSVP by</div>
            <div class="event-individual-title">{{ eventRSVPDateTime }}</div>
          </div>
        </div>
      </div><!-- /.event-card-head -->
      
      <div class="row">
        <div class="col-12">
          <div class="event-card-head" v-if="item.EventVenueAddress1">
            <div class="d-flex">
              <div class="event-card-avatar">
                <div class="event-initial-bg"></div>
                <div class="event-initial-text font-light"><img src="../../assets/icons/map-pin-icon.svg" alt="Map"></div>
              </div>
              <div class="event-card-title">
                <div class="event-individual-price font-light">Venue</div>
                <div class="event-individual-title">{{ item.EventVenueAddress1 }}</div>
                <div class="event-individual-title">{{ item.EventVenueAddress2 }}</div>
                <div class="event-individual-title">{{ item.EventVenueAddress3 }}</div>
                <div class="event-individual-title">{{ item.EventVenueSuburb }}, {{ item.EventVenueState }} {{ item.EventVenuePostcode }}</div>
              </div>
            </div>
          </div><!-- /.event-card-head -->
          <div class="event-card-head" v-if="!item.EventVenueAddress1 && item.EventVenueName">
            <div class="d-flex">
              <div class="event-card-avatar">
                <div class="event-initial-bg"></div>
                <div class="event-initial-text font-light"><img src="../../assets/icons/map-pin-icon.svg" alt="Map"></div>
              </div>
              <div class="event-card-title">
                <div class="event-individual-price font-light">Venue</div>
                <div class="event-individual-title">{{ item.EventVenueName }}</div>
              </div>
            </div>
          </div><!-- /.event-card-head -->
        </div>  
      </div>  


      <div class="event-card-head" v-if="item.EventDressCode">
        <div class="d-flex">
          <div class="event-card-avatar">
            <div class="event-initial-bg"></div>
            <div class="event-initial-text font-light"><img src="../../assets/icons/dress-code-icon.svg"
                alt="Dress Code"></div>
          </div>
          <div class="event-card-title">
            <div class="event-individual-price font-light">Dress code</div>
            <div class="event-individual-title">{{ item.EventDressCode }}</div>
          </div>
        </div>
      </div><!-- /.event-card-head -->
      <div class="event-card-head event-card-head-last" v-if="item.EventDoorsOpenDateTime">
        <div class="d-flex">
          <div class="event-card-avatar">
            <div class="event-initial-bg"></div>
            <div class="event-initial-text font-light"><img src="../../assets/icons/clock-icon.svg" alt="Clock"></div>
          </div>
          <div class="event-card-title">
            <div class="event-individual-price font-light">Doors open time</div>
            <div class="event-individual-title">{{ eventDoorsOpenDateTime }}</div>
          </div>
        </div>
      </div><!-- /.event-card-head -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    status: { type: String },
    item: { type: Object, default: null }
  },
  data() {
    return {
      showDropdown: false
    }
  },
  computed: {
    isTBA() {
      return this.item.EventDateTimeTBA
    },


    eventBeginDate: function () {
      if (this.isTBA) return "TBA";
      return this.$dateFormat(this.item.EventBeginDateTime, "DD MMM YYYY");
    },
    eventBeginTime: function () {
      if (this.isTBA) return "TBA";
      return this.$dateFormat(this.item.EventBeginDateTime, "h:mm A");
    },
    eventEndTime: function () {
      return this.$dateFormat(this.item.EventEndDateTime, "h:mm A");
    },
    eventRSVPDateTime: function () {
      return this.$dateFormat(this.item.EventRSVPDateTime, "DD MMM YYYY");
    },
    eventDoorsOpenDateTime: function () {
      return this.$dateFormat(this.item.EventDoorsOpenDateTime, "h:mm A");
    },
  }
}
</script>
